export const inventoryProducts = [
    {
        id: 'inv-1',
        nombre: 'Electrocardiografo',
        modelo: 'ECG-200',
        tipo_id: 1,
        tipo: {id: 1, nombre: 'Equipo medico'},
        configuracion: '12 derivaciones, bateria integrada',
        cantidad: 4,
        idioma: 'Espanol',
        ultima_calibracion: '2026-01-15',
        fecha_caducidad: '',
        necesita_refrigeracion: false
    },
    {
        id: 'inv-2',
        nombre: 'Monitor multiparametrico',
        modelo: 'Monitor MX5',
        tipo_id: 1,
        tipo: {id: 1, nombre: 'Equipo medico'},
        configuracion: 'SpO2, NIBP, ECG 5 leads',
        cantidad: 2,
        idioma: 'Ingles',
        ultima_calibracion: '',
        fecha_caducidad: '',
        necesita_refrigeracion: false
    },
    {
        id: 'inv-3',
        nombre: 'Bomba de infusion',
        modelo: 'Bomba de infusion B120',
        tipo_id: 2,
        tipo: {id: 2, nombre: 'Reactivo'},
        configuracion: 'Volumetrica, alarmas sonoras',
        cantidad: 6,
        idioma: 'Espanol',
        ultima_calibracion: '2025-12-02',
        fecha_caducidad: '2027-01-15',
        necesita_refrigeracion: true
    }
];
